// libs
import { connect } from "react-redux";
import unescape from "lodash/unescape";

// components
import HeaderSearch from "./HeaderSearch";

// selectors
import { getAppSearchTerm } from "shared/store/app/selectors";

const mapStateToProps = (state: any) => ({
    // unescaping search term, escaping would be handled by react
    initialSearchTerm: unescape(getAppSearchTerm(state)),
});

export default connect(mapStateToProps)(HeaderSearch);
